export default __webpack_public_path__ + "static/media/circle_gishgallop.5e91d445.png";